import React, { useState, useEffect } from 'react';

function CookieConsent() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Check if user has already accepted cookies
        const consent = localStorage.getItem('cookieConsent');
        if (!consent) {
            setIsVisible(true);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookieConsent', 'true');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 z-[100] md:max-w-md p-6 bg-slate-900/95 dark:bg-[#0f172a]/95 backdrop-blur-md rounded-xl border border-slate-700 shadow-2xl animate-fade-in-up">
            <div className="flex flex-col gap-4">
                <div>
                    <div className="flex items-center gap-2 mb-2">
                        <span className="material-symbols-outlined text-amber-400">cookie</span>
                        <h3 className="text-white font-bold text-lg">Cookie Preferences</h3>
                    </div>
                    <p className="text-slate-300 text-sm leading-relaxed">
                        This website uses cookies and similar technologies to ensure proper functionality, analyze traffic, and improve your experience. Some cookies may be set by third-party services. You can accept all cookies or manage your preferences at any time.
                    </p>
                </div>
                <div className="flex justify-end">
                    <button
                        onClick={handleAccept}
                        className="px-6 py-2.5 bg-primary hover:bg-primary/90 text-white text-sm font-bold rounded-lg transition-colors shadow-lg hover:shadow-primary/25 whitespace-nowrap"
                    >
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;
